import { DrawStage } from '../../../types/Draw';
import { GeneratedProductReleaseType } from '../../../types/generated';
import { CheckoutFlowType } from '../types';

type ResolveCheckoutFlowTypeArgs = {
  releaseType: GeneratedProductReleaseType | null | undefined;
  stage: DrawStage;
};

export const resolveCheckoutFlowType = ({
  releaseType,
  stage,
}: ResolveCheckoutFlowTypeArgs): CheckoutFlowType | null => {
  if (releaseType === GeneratedProductReleaseType.Timed) return 'timed';
  if (releaseType === GeneratedProductReleaseType.Public) return 'fcfs';
  if (releaseType === GeneratedProductReleaseType.Private) return 'fcfs';
  if (releaseType !== GeneratedProductReleaseType.Draw) return null;

  switch (stage) {
    case 'DRAW':
    case 'DRAW_PRE_ORDER_CLOSED':
      return 'draw';
    case 'DRAW_PRE_ORDER_OPEN':
    case 'FCFS_PRE_ORDER_OPEN':
      return 'preOrder';
    default:
      return null;
  }
};
